// extracted by mini-css-extract-plugin
module.exports = {"userTable":"userTable_userTable__3cSyE"};